var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEmptyCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#1C2743",
    d: "m6.1875,2.5l5.625,0l0,-1.5625c0,-0.51758 0.418,-0.9375 0.9375,-0.9375c0.5195,0 0.9375,0.41992 0.9375,0.9375l0,1.5625l1.5625,0c1.3789,0 2.5,1.11914 2.5,2.5l0,6.25l0,6.25c0,1.3789 -1.1211,2.5 -2.5,2.5l-12.5,0c-1.38086,0 -2.5,-1.1211 -2.5,-2.5l0,-12.5c0,-1.38086 1.11914,-2.5 2.5,-2.5l1.5625,0l0,-1.5625c0,-0.51758 0.41797,-0.9375 0.9375,-0.9375c0.51953,0 0.9375,0.41992 0.9375,0.9375l0,1.5625zm-4.0625,15c0,0.3438 0.27969,0.625 0.625,0.625l12.5,0c0.3437,0 0.625,-0.2812 0.625,-0.625l0,-10l-13.75,0l0,10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEmptyCalendar);
export default __webpack_public_path__ + "static/media/ico-empty-calendar.391cfa81810c196b6967661e8a1564b7.svg";
export { ForwardRef as ReactComponent };